const PayerGroupIndex = () => import('./pages/payer_group/index')
const PayerGroupNew = () => import('./pages/payer_group/new')
const PayerGroupEdit = () => import('./pages/payer_group/edit')
const PayerGroupFormInfos = () => import('./components/payer_group/infos')
const PayerGroupFormTaxLimit = () => import('./components/payer_group/tax-limit')

const PayerIndex = () => import('./pages/payers/index')
const PayerEdit = () => import('./pages/payers/edit')
const PayerNew = () => import('./pages/payers/new')
const PayerFormInfos = () => import('./components/payers/form/infos')
const FormContact = () => import('./components/payers/form/contact')
const FormBranchOffices = () => import('./components/payers/form/branch_offices')
const FormImportRule = () => import('./components/payers/form/import-rule')
const PayerFormTaxLimit = () => import('./components/payers/form/tax-limit')
const FormLimit = () => import('./components/payers/form/limit')
const TermFee = () => import('./components/payers/form/term-fee-spreadsheets')
const FormFunds = () => import('./components/payers/form/funds')
const DocsPayer = () => import('./components/payers/form/docs')
const ListAssignors = () => import('./components/payers/form/list-assignors')
const Users = () => import('./components/payers/form/users')
const Classification = () => import('./components/payers/form/classification/classification')

const AssignorsIndex = () => import('./pages/assignors/index')
const AssignorsNew = () => import('./pages/assignors/new')
const AssignorsEdit = () => import('./pages/assignors/edit')
const FormInfos = () => import('./components/assignors/form/infos')
const AssignorsFormContact = () => import('./components/assignors/form/contact')
const BranchOffices = () => import('./components/assignors/form/branch_offices')
const AssignorsFormImportRule = () => import('./components/assignors/form/import_rule')
const FormTaxLimit = () => import('./components/assignors/form/tax-limit')
const FormBankAccount = () => import('./components/assignors/form/bank_account')
const FormRepresentative = () => import('./components/assignors/form/representative')
const FormFund = () => import('./components/assignors/form/funds')
const ListDocs = () => import('./components/assignors/form/docs')
const User = () => import('./components/assignors/form/users')
const HistorySerasa = () => import('./components/assignors/history_serasa')

export default [
  {
    path: '/clients/payer-groups',
    name: 'payer-groups.index',
    component: PayerGroupIndex,
    meta: { requiresAuth: true }
  },
  {
    path: '/clients/payer-groups/new',
    name: 'payer-groups.new',
    component: PayerGroupNew,
    meta: { requiresAuth: true }
  },
  {
    path: '/clients/payer-groups/edit/:id',
    component: PayerGroupEdit,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'payer-groups.edit.infos',
        component: PayerGroupFormInfos,
        meta: { requiresAuth: true }
      },
      {
        path: 'tax-limit',
        name: 'payer-groups.edit.tax-limit',
        component: PayerGroupFormTaxLimit,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/clients/payers',
    name: 'payers.index',
    component: PayerIndex,
    meta: { requiresAuth: true }
  },
  {
    path: '/clients/payers/new',
    component: PayerNew,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'payers.new.infos',
        component: PayerFormInfos,
        meta: { requiresAuth: true }
      },
      {
        path: 'contact',
        name: 'payers.new.contact',
        component: FormContact,
        meta: { requiresAuth: true }
      },
      {
        path: 'import-rule',
        name: 'payers.new.import-rule',
        component: FormImportRule,
        meta: { requiresAuth: true }
      },
      {
        path: 'tax-limit',
        name: 'payers.new.tax-limit',
        component: PayerFormTaxLimit,
        meta: { requiresAuth: true }
      },
      {
        path: 'limit',
        name: 'payers.new.limit',
        component: FormLimit,
        meta: { requiresAuth: true }
      },
      {
        path: 'docs',
        name: 'payers.new.docs',
        component: DocsPayer,
        meta: { requiresAuth: true }
      },
      {
        path: 'funds',
        name: 'payers.new.funds',
        component: FormFunds,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/clients/payers/edit/:id',
    component: PayerEdit,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'payers.edit.infos',
        component: PayerFormInfos,
        meta: { requiresAuth: true }
      },
      {
        path: 'branch_offices',
        name: 'payers.edit.branch_offices',
        component: FormBranchOffices,
        meta: { requiresAuth: true }
      },
      {
        path: 'contact',
        name: 'payers.edit.contact',
        component: FormContact,
        meta: { requiresAuth: true }
      },
      {
        path: 'import-rule',
        name: 'payers.edit.import-rule',
        component: FormImportRule,
        meta: { requiresAuth: true }
      },
      {
        path: 'tax-limit',
        name: 'payers.edit.tax-limit',
        component: PayerFormTaxLimit,
        meta: { requiresAuth: true }
      },
      {
        path: 'limit',
        name: 'payers.edit.limit',
        component: FormLimit,
        meta: { requiresAuth: true }
      },
      {
        path: 'term-fee',
        name: 'payers.new.term-fee',
        component: TermFee,
        meta: { requiresAuth: true }
      },
      {
        path: 'docs',
        name: 'payers.edit.docs',
        component: DocsPayer,
        meta: { requiresAuth: true }
      },
      {
        path: 'assignors',
        name: 'payers.edit.assignors',
        component: ListAssignors,
        meta: { requiresAuth: true }
      },
      {
        path: 'funds',
        name: 'payers.edit.funds',
        component: FormFunds,
        meta: { requiresAuth: true }
      },
      {
        path: 'users',
        name: 'payers.edit.users',
        component: Users,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/clients/payers/edit/:id/classification',
    name: 'payers.edit.classification',
    component: Classification,
    meta: { requiresAuth: true }
  },
  {
    path: '/clients/payers/classification',
    name: 'payers.classification',
    component: Classification,
    meta: { requiresAuth: true }
  },
  {
    path: '/assignors',
    name: 'assignors.index',
    component: AssignorsIndex,
    meta: { requiresAuth: true }
  },
  {
    path: '/assignors/new',
    component: AssignorsNew,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'assignors.new.infos',
        component: FormInfos,
        meta: { requiresAuth: true }
      },
      {
        path: 'contact',
        name: 'assignors.new.contact',
        component: AssignorsFormContact,
        meta: { requiresAuth: true }
      },
      {
        path: 'import_rule',
        name: 'assignors.new.import_rule',
        component: AssignorsFormImportRule,
        meta: { requiresAuth: true }
      },
      {
        path: 'tax_limit',
        name: 'assignors.new.tax_limit',
        component: FormTaxLimit,
        meta: { requiresAuth: true }
      },
      {
        path: 'bank_account',
        name: 'assignors.new.bank_account',
        component: FormBankAccount,
        meta: { requiresAuth: true }
      },
      {
        path: 'representative',
        name: 'assignors.new.representative',
        component: FormRepresentative,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/assignors/edit/:id',
    component: AssignorsEdit,
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'assignors.edit',
        component: FormInfos,
        meta: { requiresAuth: true }
      },
      {
        path: 'contact',
        name: 'assignors.edit.contact',
        component: AssignorsFormContact,
        meta: { requiresAuth: true }
      },
      {
        path: 'branch_offices',
        name: 'assignors.edit.branch_offices',
        component: BranchOffices,
        meta: { requiresAuth: true }
      },
      {
        path: 'import_rule',
        name: 'assignors.edit.import_rule',
        component: AssignorsFormImportRule,
        meta: { requiresAuth: true }
      },
      {
        path: 'tax_limit',
        name: 'assignors.edit.tax_limit',
        component: FormTaxLimit,
        meta: { requiresAuth: true }
      },
      {
        path: 'bank_account',
        name: 'assignors.edit.bank_account',
        component: FormBankAccount,
        meta: { requiresAuth: true }
      },
      {
        path: 'representative',
        name: 'assignors.edit.representative',
        component: FormRepresentative,
        meta: { requiresAuth: true }
      },
      {
        path: 'serasa',
        name: 'assignors.history_serasa',
        component: HistorySerasa,
        meta: { requiresAuth: true }
      },
      {
        path: 'docs',
        name: 'assignors.edit.docs',
        component: ListDocs,
        meta: { requiresAuth: true }
      },
      {
        path: 'funds',
        name: 'assignors.edit.funds',
        component: FormFund,
        meta: { requiresAuth: true }
      },
      {
        path: 'users',
        name: 'assignors.edit.users',
        component: User,
        meta: { requiresAuth: true }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/features/clients/routes.js